<p-fieldset legend="visita técnica">
  <div class="row">
    <label class="required col-4 col-form-label">
      Há exigência de visita técnica?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3" [(ngModel)]="objeto.VistaTecnicaNao"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <div class="row mt-2" *ngIf="objeto.VistaTecnicaNao === 'S'">
    <label class="col-4 col-form-label">
      Quantidade de empresas que realizaram visita técnica
    </label>
    <input type="text" class="col-2 form-control" [(ngModel)]="objeto.VistaTecnica.VTecQtidadeEmpresas"
      [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
  </div>
  <div class="row mt-2" *ngIf="objeto.VistaTecnicaNao === 'S'">
    <label class="col-4 col-form-label">
      Item do Edital
    </label>
    <input type="text" class="col-2 form-control" [(ngModel)]="objeto.VistaTecnica.VTecItemEdital"
      [ngModelOptions]="{standalone: true}">
  </div>
  <div class="row mt-2" *ngIf="objeto.VistaTecnicaNao === 'S'">
    <label class="col-4 col-form-label">
      Prazo (em dias) para a realização da visita técnica
    </label>
    <input type="text" class="col-2 form-control" [(ngModel)]="objeto.VistaTecnica.VTecPrazoEmDias"
      [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
  </div>
  <div class="row mt-2" *ngIf="objeto.VistaTecnicaNao === 'S'">
    <label class="required col-4 col-form-label">
      Há exigência de apresentação de currículo dos profissionais indicados para a visita técnica?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="objeto.VistaTecnica.VTecExigeCurriculoProfissional" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <div class="row mt-2" *ngIf="objeto.VistaTecnicaNao === 'S'">
    <label class="required col-4 col-form-label">
      Há exigência de visto do CREA/SP para empresas sediadas em outros estados?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="objeto.VistaTecnica.VTecExigeCREA_SP" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
</p-fieldset>